import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: 4,
    position: 'absolute',
    top: '110%',
    maxHeight: 200,
    width: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    backgroundColor: '#fff',
    zIndex: 1,
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
    borderRadius: 5
  },
  notFound: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 30,
    color: '#596375',
    fontWeight: 'bold'
  }
});
